import { render, staticRenderFns } from "./ListAnulada.vue?vue&type=template&id=4dcb651a&"
import script from "./ListAnulada.vue?vue&type=script&lang=js&"
export * from "./ListAnulada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports